export const environment = {
  production: false,
  url: '',
  apiUrl: 'https://medismartposapidev.clavisco.com/API/',
  env: 'Development',
  urlReportManager: 'https://rptmngapiv2.clavisco.com/',
  companyKey: '39',
  appKey: '53',
  LogRocketId: ''
};
